import {
  COURSE_INCLUDES,
  COURSE_INFO,
  COURSE_VIDEO,
} from '@components/locale-pages/home/courses'
import ResponsiveCourseCard from './responsive-course-card'
import Modal from '@components/common/modal'
import { useState } from 'react'
import RecommendedCoursesVideo from './recommended-courses-video'
import { Trans } from '@lingui/macro'
import { FastlyImage } from '@components/common/image'

type Props = {
  courseCodes?: string[]
  title: string
  description?: JSX.Element
  courseName: string
}

const ClassCurriculum = ({
  courseCodes,
  title,
  description,
  courseName,
}: Props) => {
  const [ismodalOpen, setModalOpen] = useState(false)
  const [videoURL, setVideoURL] = useState('')

  const courseVideos = COURSE_VIDEO[courseName]

  const courseIncludes = COURSE_INCLUDES[courseName]

  return (
    <>
      <Modal
        isOpen={ismodalOpen}
        setIsOpen={setModalOpen}
        isCrossIconShown={true}
        shouldCloseOnEsc
        width="mt-12 sm:mt-5 lg:max-w-lg"
      >
        <iframe
          src={videoURL}
          width="485"
          height="402"
          scrolling="no"
          allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
          className="border border-grey-600 rounded-md max-w-full"
        />
      </Modal>

      <div className="m-10 flex flex-col text-grey container mx-auto lg:px-3 py-5">
        <h2 className="text-2xl md:text-2xl font-600 mb-4 leading-tight">
          {title}
        </h2>
        {courseCodes && courseCodes.length !== 0 && (
          <div className="flex flex-wrap justify-around gap-4 mb-4">
            {courseCodes.map((code, index) => (
              <ResponsiveCourseCard key={index} course={COURSE_INFO[code]} />
            ))}
          </div>
        )}
        {courseVideos?.length > 0 && (
          <h3 className="text-lg font-600 text-center mb-3">
            Dive In! Watch Videos and Explore Our Curriculum in Action!
          </h3>
        )}

        {courseVideos?.length > 0 && (
          <div className="flex justify-center mb-4 gap-4 flex-wrap">
            {courseVideos.map((e, i) => (
              <RecommendedCoursesVideo
                key={i}
                setModalOpen={setModalOpen}
                setVideoURL={setVideoURL}
                video={e}
              />
            ))}
          </div>
        )}
        {description && <p className="lg:text-lg">{description}</p>}
        {courseIncludes && (
          <div className="flex flex-col gap-4 mt-8">
            {courseIncludes.map((e, i) => (
              <div className="p-4 shadow-md rounded-md bg-white" key={i}>
                <div className="flex items-center gap-4 mb-3">
                  <div>
                    {
                      <FastlyImage
                        src={`/images/courses/icons/${e.icon}.png`}
                        alt={e.title}
                        width={40}
                        height={40}
                        className="h-12 w-12 object-contain"
                      />
                    }
                  </div>
                  <h3 className="text-lg md:text-2xl font-500 leading-tight">
                    <Trans>{e.title}</Trans>
                  </h3>
                </div>
                <span className="block">
                  <Trans>{e.description}</Trans>
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default ClassCurriculum
